import { Box } from "@chakra-ui/react"
export const MediaItem = (props) => {
    return (
        <Box>
            {props.children}
        </Box>
    )
}